import { relations } from 'drizzle-orm';
import { tenantUsers } from '../models/tenantUsers';
import { tenants } from '../models/tenants';
import { users } from '../models/users';

/**
 * @group TenantUser
 * @summary TenantUser relations for the database schema
 *
 * @remarks
 * Defines the relationships for the tenantUsers table, including tenant and user.
 *
 * @example
 * ```typescript
 * import { tenantUserRelations } from '@shared/db';
 *
 * // Query tenantUser with tenant and user
 * const tenantUserWithDetails = await db.query.tenantUsers.findFirst({
 *   where: eq(tenantUsers.id, tenantUserId),
 *   with: {
 *     tenant: true,
 *     user: true
 *   }
 * });
 * ```
 */
export const /**
 * @internal
 */
tenantUserRelations = relations(tenantUsers, ({ one }) => ({
  tenant: one(tenants, {
    fields: [tenantUsers.tenant_id],
    references: [tenants.id],
  }),
  user: one(users, {
    fields: [tenantUsers.user_id],
    references: [users.id],
  }),
}));
